export default __webpack_public_path__ + "static/bannerMb-d5c8596aef8be45130454a7e187e75f9.png";